<ul
  class="menu h-full w-52 border-r border-base-300 bg-base-200 p-0 text-base print:hidden [&_li>*]:rounded-none"
>
  @if (signedIn) {
    @if (viewService.currentView === 'user') {
      <li>
        <a
          routerLink="/"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="active text-xl normal-case"
        >
          <app-home-icon class="h-5 w-5 text-current"></app-home-icon>
          Dashboard
        </a>
      </li>
      <li>
        <a
          routerLink="/licenses"
          routerLinkActive="active"
          class="text-xl normal-case"
        >
          <app-clipboard-icon class="h-5 w-5 text-current"></app-clipboard-icon>
          Licenses
        </a>
      </li>
      <li>
        <a
          routerLink="/des-credits"
          routerLinkActive="active"
          class="text-xl normal-case"
        >
          <app-dollar-icon class="h-5 w-5 text-current"></app-dollar-icon>
          DES Credits
        </a>
      </li>
      @if (showApiInvoices) {
        <li>
          <a
            routerLink="/api-invoices"
            routerLinkActive="active"
            class="text-xl normal-case"
          >
            <app-file-code-icon
              class="h-5 w-5 text-current"
            ></app-file-code-icon>
            API Invoices
          </a>
        </li>
        <li>
          <a
            routerLink="/api-job-logs"
            routerLinkActive="active"
            class="text-xl normal-case"
          >
            <app-list-icon class="h-5 w-5 text-current"></app-list-icon>
            API Job Logs
          </a>
        </li>
      }
      <li>
        <a
          routerLink="/receipts"
          routerLinkActive="active"
          class="text-xl normal-case"
        >
          <app-file-invoice-icon
            class="h-5 w-5 text-current"
          ></app-file-invoice-icon>
          Receipts
        </a>
      </li>

      <li>
        <a
          routerLink="/tenant/users"
          routerLinkActive="active"
          class="text-xl normal-case"
        >
          <app-users-icon class="h-5 w-5 text-current"></app-users-icon>
          Users
        </a>
      </li>
      <li>
        <a
          routerLink="/saved-payment-methods"
          routerLinkActive="active"
          class="text-xl normal-case"
        >
          <app-credit-card-icon
            class="h-5 w-5 text-current"
          ></app-credit-card-icon>
          Saved Payment
        </a>
      </li>
    }

    @if (viewService.currentView === 'admin' && (isAdmin || canAccessPricing)) {
      @if (isAdmin) {
        <li>
          <a
            routerLink="/admin/tenants"
            routerLinkActive="active"
            class="text-xl normal-case"
          >
            <app-users-icon class="h-5 w-5 text-current"></app-users-icon>
            Tenants
          </a>
        </li>
        <li>
          <a
            routerLink="/admin/invoices"
            routerLinkActive="active"
            class="text-xl normal-case"
          >
            <app-receipt-icon class="h-5 w-5 text-current"></app-receipt-icon>
            Invoices
          </a>
        </li>
        <li>
          <a
            routerLink="/admin/licenses"
            routerLinkActive="active"
            class="text-xl normal-case"
          >
            <app-rectangle-list-icon
              class="h-5 w-5 text-current"
            ></app-rectangle-list-icon>
            Licenses
          </a>
        </li>
        <li>
          <a
            routerLink="/admin/products"
            routerLinkActive="active"
            class="text-xl normal-case"
          >
            <app-clipboard-icon
              class="h-5 w-5 text-current"
            ></app-clipboard-icon>
            Products
          </a>
        </li>
      }
      @if (canAccessPricing) {
        <li>
          <a
            routerLink="/admin/pricing"
            routerLinkActive="active"
            class="text-xl normal-case"
          >
            <app-dollar-icon class="h-5 w-5 text-current"></app-dollar-icon>
            Pricing
          </a>
        </li>
      }
      @if (isAdmin) {
        <li>
          <a
            routerLink="/admin/franchises"
            routerLinkActive="active"
            class="text-xl normal-case"
          >
            <app-building-icon class="h-5 w-5 text-current"></app-building-icon>
            Franchises
          </a>
        </li>
        <li>
          <a
            routerLink="/admin/kill-switch"
            routerLinkActive="active"
            class="text-xl normal-case"
          >
            <app-cog-icon class="h-5 w-5 text-current"></app-cog-icon>
            Kill Switch
          </a>
        </li>
        @if (isActivationKeysAdmin) {
          <li>
            <a
              routerLink="/admin/activation-keys"
              routerLinkActive="active"
              class="text-xl normal-case"
            >
              <app-lock-open-icon
                class="h-5 w-5 text-current"
              ></app-lock-open-icon>
              Activation keys
            </a>
          </li>
        }
        @if (isRegistrationDbAdmin) {
          <li>
            <a
              routerLink="/admin/registration-db-logs"
              routerLinkActive="active"
              class="text-xl normal-case"
            >
              <app-database-icon
                class="h-5 w-5 text-current"
              ></app-database-icon>
              Reg. DB Logs
            </a>
          </li>
        }
        @if (isSuperAdmin) {
          <li>
            <a
              routerLink="/admin/log-search"
              routerLinkActive="active"
              class="text-xl normal-case"
            >
              <app-list-icon class="h-5 w-5 text-current"></app-list-icon>
              Log Search
            </a>
          </li>
          <li>
            <a
              routerLink="/admin/product-squash"
              routerLinkActive="active"
              class="text-xl normal-case"
            >
              <app-share-all-icon
                class="h-5 w-5 text-current"
              ></app-share-all-icon>
              Product Squash
            </a>
          </li>
        }
      }
    }

    <li>
      @if (isAdmin || canAccessPricing) {
        @if (viewService.currentView === 'user') {
          <a (click)="switchView('admin')" class="text-xl normal-case">
            <app-refresh-icon class="h-5 w-5 text-current"></app-refresh-icon>
            Admin View
          </a>
        } @else {
          <span (click)="switchView('user')" class="text-xl normal-case">
            <app-refresh-icon class="h-5 w-5 text-current"></app-refresh-icon>
            User View
          </span>
        }
      }
    </li>
  }
  <li class="mt-auto">
    <a routerLink="/faq" class="text-sm normal-case text-base-content/70"
      >Frequently Asked Questions</a
    >
  </li>
  <li>
    <a
      routerLink="/privacy-policy"
      class="text-sm normal-case text-base-content/70"
      >Privacy</a
    >
  </li>
  <li>
    <a
      routerLink="/cookie-policy"
      class="text-sm normal-case text-base-content/70"
      >Cookies</a
    >
  </li>
  <!-- <li>
    <a
      (click)="openConsentPreferences()"
      class="text-sm normal-case text-base-content/70"
      >Manage Cookies</a
    >
  </li> -->
  <p class="mb-4 px-4 py-2 text-sm normal-case text-base-content/70">
    © {{ year }} AccuZIP Inc.
  </p>
</ul>
